<template>
	<div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="orders" v-loading="loading"
				:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
				style="width: 100%">
				<el-table-column label="商品封面" align="center" width="200px">
					<template slot-scope="scope">
						<el-image style="width: 80px; height: 80px" :src="scope.row.picture" :fit="fit"></el-image>
					</template>
				</el-table-column>
				<el-table-column label="商品名称" align="center">
					<template slot-scope="scope">
						{{ scope.row.goodsTitle}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="total" label="商品价格">
					<template slot-scope="scope">
						{{ scope.row.amount == null ? '0' : (scope.row.amount/100).toFixed(2)}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="商品券">
					<template slot-scope="scope">
						{{ scope.row.couponName ? scope.row.couponName : '/' }}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="payTime" label="销售时间">
					<template slot-scope="scope">
						{{ scope.row.soldStartTime ? scope.row.soldStartTime : '' }}-
						{{ scope.row.soldEndTime ? scope.row.soldEndTime : '' }}
					</template>
				</el-table-column>
				</el-table-column>
				<el-table-column align="center" label="操作" width="250" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="show(scope.row.dyGoodsId)">编辑</el-button>
						<el-button v-if="scope.row.status==1" type="text" size="small"
							@click="onOrOff(scope.row.dyGoodsId,2)">下架</el-button>
						<el-button v-if="scope.row.status==2" type="text" size="small"
							@click="onOrOff(scope.row.dyGoodsId,1)" style="color:#e36">上架</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: center;">
				<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
					style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
					:total="query.total">
				</el-pagination>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	import {
		url,
		formatMoney
	} from '../../utils/index.js'
	export default {
		data() {
			return {
				loading: false,
				url: url(),
				orders: [],
				query: {
					page: 0,
					size: 10
				},
			};
		},
		computed: {
			statusRemark() {
				return (val) => {
					let result = '';
					this.orderStateList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
			customerType() {
				return (val) => {
					let result = '';
					this.customerTypeList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
		},
		mounted() {
			this.getOrders();
		},
		methods: {
			show(id) {
				this.$router.push({
					path: "/DyGoodsEdit",
					query: {
						id: id
					}
				});
			},
			handleCurrentChange(val) {
				this.query.page = val;
				if (this.query.time[0] != undefined || this.query.time[0] != null) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			handleSizeChange(val) {
				this.query.size = val;
				if (this.query.time[0] != undefined || this.query.time[0] != null) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			onOrOff(dyGoodsId, status) {
				this.$http.get("https://cj.ciaojian.com//bytedance/goods/operate?productId=" + dyGoodsId + "&type=" +
					status).then(res => {
					console.log(res)
					this.getOrders()
					this.$message.success("上架/下架成功！");
				})
			},
			getOrders() {
				this.loading = true;
				var arr = {
					pageNum: this.query.page,
					pageSize: this.query.size,
				}
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)

				this.$http.get("dDyGoods/dyGoodsList", {
					params: arr
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.body.code == 200) {
						this.orders = res.body.data;
						this.query.total = res.body.data.total;
					} else {
						this.$message.error(res.data.msg);
					}
					this.loading = false
					clearTimeout(t)
				})
			}
		}
	};
</script>


<style lang="less" scoped>
	.grid-content {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
	}

	.main-number {
		font-family: SourceHanSansCN-Bold;
		font-size: 22px;
	}

	.topRight {
		height: 100px;
	}

	.topRight>div {
		margin-top: 5px;
	}

	.tableCol {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
		margin: 30px -3px 0px -3px;
		padding: 5px 15px 30px 15px;
	}

	.bg-purple {
		background: #FFFFFF;
	}

	.main-content {
		padding: 30px 20px 20px 20px;
	}

	.waiTitel {
		display: flex;
		border-radius: 2px;
	}

	.green01 {
		height: 14px;
		width: 5px;
		background-color: #4AB52E;
		margin: 5px 0 0 0
	}

	.topTitle {
		display: flex;
	}

	.green02 {
		width: 5px;
		height: 5px;
		background: #4AB52E;
		margin: 15px 5px 0 5px
	}

	.topTitleSmall {
		margin: 5px 0 0 0;
		font-size: 16px;
		font-family: SourceHanSansCN-Bold;
	}

	.buttonStyle {
		// margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		background: #FFFFFF !important;
		border-radius: 5px;
		border: 1px solid #CBC9C9;
	}

	.buttonStyle01 {
		margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		color: #FFFFFF;
		background: #4AB52E !important;
		border-radius: 5px;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #4AB52E;
		border-radius: 5px;
		color: #FFF;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #4AB52E;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled) {
		border-radius: 5px;
	}

	/deep/.el-icon-arrow-down:before {
		content: "\e6d1";

	}

	.Red {
		color: red;
	}
</style>